import "./styles.scss";

const BottomList = ({ goToSite }) => (
  <>
    <h4 className="support-chain">Supported Chains</h4>
    <ul className="bottom-list">
      <li>
        <svg
          width="32"
          height="29"
          viewBox="0 0 32 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.7606 17.5717C24.5228 16.2551 25.7527 16.2551 26.5149 17.5717L31.2614 25.9039C32.0236 27.2205 31.4 28.2945 29.8756 28.2945H20.3134C18.8063 28.2945 18.1827 27.2205 18.9275 25.9039L23.7606 17.5717ZM14.5795 1.53071C15.3417 0.214171 16.5543 0.214171 17.3165 1.53071L18.3732 3.43622L20.8677 7.8189C21.474 9.06614 21.474 10.5386 20.8677 11.7858L12.5008 26.285C11.7386 27.463 10.474 28.2079 9.07086 28.2945H2.1244C0.59999 28.2945 -0.0236316 27.2378 0.738573 25.9039L14.5795 1.53071Z"
            fill="white"
          />
        </svg>
      </li>
      <li>
        <svg
          width="32"
          height="31"
          viewBox="0 0 32 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.1072 13.3363L15.9999 7.44358L21.8955 13.3389L25.3242 9.91018L15.9999 0.586182L6.6787 9.90739L10.1073 13.3361L10.1072 13.3363ZM0.828674 15.7574L4.2575 12.3281L7.68607 15.7567L4.25725 19.1855L0.828674 15.7574ZM10.1072 18.1789L15.9999 24.0713L21.8953 18.1761L25.3259 21.603L25.3242 21.6048L15.9999 30.9287L6.6787 21.6075L6.67385 21.6026L10.1075 18.1785L10.1072 18.1789ZM24.3138 15.7589L27.7426 12.3301L31.1712 15.7586L27.7425 19.1875L24.3138 15.7589Z"
            fill="white"
          />
          <path
            d="M19.4774 15.7557H19.4788L15.9999 12.2765L13.4284 14.8472L13.133 15.1428L12.5237 15.7522L12.5189 15.7569L12.5237 15.7619L15.9999 19.2385L19.4791 15.7593L19.4808 15.7574L19.4776 15.7557"
            fill="white"
          />
        </svg>
      </li>
      <li>
        <svg
          width="17"
          height="28"
          viewBox="0 0 17 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M8.18842 0.25L8.0041 0.876499V19.056L8.18842 19.24L16.6272 14.2519L8.18842 0.25Z"
              fill="white"
            />
            <path
              d="M8.18881 0.25L-0.249928 14.2519L8.18881 19.2401V10.4163V0.25Z"
              fill="white"
            />
            <path
              d="M8.18853 20.838L8.08467 20.9646V27.4406L8.18853 27.744L16.6323 15.8524L8.18853 20.838Z"
              fill="white"
            />
            <path
              d="M8.18881 27.744V20.838L-0.249929 15.8524L8.18881 27.744Z"
              fill="white"
            />
            <path
              d="M8.18806 19.2401L16.6267 14.2521L8.18806 10.4165V19.2401Z"
              fill="white"
            />
            <path
              d="M-0.249929 14.2521L8.18868 19.2401V10.4165L-0.249929 14.2521Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="16.8825"
                height="27.5"
                fill="white"
                transform="translate(0.0641985 0.25)"
              />
            </clipPath>
          </defs>
        </svg>
      </li>
      <li>
        <svg
          width="22"
          height="29"
          viewBox="0 0 22 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M10.9011 0.586212C4.96671 0.61005 0.161777 5.41498 0.137939 11.3494C0.137939 12.5378 0.329774 13.7183 0.705496 14.8455C0.985869 15.6128 1.81791 16.026 2.59887 15.7888C3.35372 15.4993 3.75441 14.6741 3.51377 13.9022C3.1948 13.0236 3.05291 12.0917 3.09491 11.1587C3.22431 6.87247 6.80333 3.50232 11.0895 3.63172C15.3757 3.76112 18.7459 7.34014 18.6165 11.6263C18.495 15.639 15.3348 18.8979 11.3268 19.1419C11.3268 19.1419 9.81592 19.2339 9.06447 19.3258C8.78751 19.3655 8.51281 19.42 8.24152 19.4893C8.20292 19.529 8.14049 19.529 8.10076 19.4904L8.09963 19.4893C8.07238 19.4541 8.07238 19.4041 8.09963 19.3689L8.33346 18.0931L9.75235 11.7115C9.92262 10.9146 9.41522 10.1302 8.61837 9.95998C7.82152 9.78971 7.03716 10.2971 6.86689 11.094C6.86689 11.094 3.4922 26.7143 3.4922 26.8561C3.29923 27.6155 3.75782 28.3874 4.51721 28.5804C4.52515 28.5826 4.53423 28.5849 4.54218 28.5861H4.6205C5.37876 28.7824 6.15291 28.3261 6.34815 27.5679C6.35155 27.5554 6.35496 27.5429 6.35723 27.5293C6.35496 27.5054 6.35496 27.4816 6.35723 27.4589C6.39923 27.275 6.82489 25.1966 6.82489 25.1966C7.14727 23.6279 8.41178 22.4258 9.99413 22.1829C10.3199 22.1329 11.6889 22.041 11.6889 22.041C17.6005 21.4519 21.9151 16.1815 21.3248 10.2699C20.7868 4.87808 16.3201 0.726966 10.9011 0.586212Z"
              fill="white"
            />
            <path
              d="M11.5535 25.4034C10.583 25.2014 9.63401 25.8246 9.43196 26.794C9.42969 26.803 9.42855 26.8121 9.42628 26.8212C9.21629 27.7849 9.82698 28.7373 10.7918 28.9473C10.793 28.9473 10.7941 28.9473 10.7952 28.9484H10.8452C11.7896 29.1766 12.7397 28.5954 12.9667 27.6521C12.969 27.6453 12.9701 27.6374 12.9724 27.6305V27.5318C13.1392 26.5579 12.5172 25.6237 11.5535 25.4034Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="21.2414"
                height="28.4119"
                fill="white"
                transform="translate(0.137939 0.586212)"
              />
            </clipPath>
          </defs>
        </svg>
      </li>
      <li>
        <svg
          width="28"
          height="24"
          viewBox="0 0 28 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.7601 7.28463C20.265 7.00173 19.6285 7.00173 19.0627 7.28463L15.1022 9.61854L12.4146 11.1038L8.52477 13.4377C8.0297 13.7206 7.39318 13.7206 6.82738 13.4377L3.78623 11.5988C3.29116 11.3159 2.93753 10.7501 2.93753 10.1136V6.57738C2.93753 6.01159 3.22043 5.44579 3.78623 5.09217L6.82738 3.32405C7.32245 3.04116 7.95898 3.04116 8.52477 3.32405L11.5659 5.16289C12.061 5.44579 12.4146 6.01159 12.4146 6.64811V8.98202L15.1022 7.42608V5.02144C15.1022 4.45565 14.8193 3.88985 14.2535 3.53623L8.5955 0.212174C8.10042 -0.0707245 7.4639 -0.0707245 6.89811 0.212174L1.09869 3.60695C0.532898 3.88985 0.25 4.45565 0.25 5.02144V11.6695C0.25 12.2353 0.532898 12.8011 1.09869 13.1548L6.82738 16.4788C7.32245 16.7617 7.95898 16.7617 8.52477 16.4788L12.4146 14.2156L15.1022 12.6597L18.992 10.3965C19.4871 10.1136 20.1236 10.1136 20.6894 10.3965L23.7306 12.1646C24.2256 12.4475 24.5792 13.0133 24.5792 13.6498V17.1861C24.5792 17.7519 24.2963 18.3177 23.7306 18.6713L20.7601 20.4394C20.265 20.7223 19.6285 20.7223 19.0627 20.4394L16.0216 18.6713C15.5265 18.3884 15.1729 17.8226 15.1729 17.1861V14.9229L12.4853 16.4788V18.8127C12.4853 19.3785 12.7682 19.9443 13.334 20.2979L19.0627 23.622C19.5578 23.9049 20.1943 23.9049 20.7601 23.622L26.4888 20.2979C26.9839 20.015 27.3375 19.4493 27.3375 18.8127V12.0939C27.3375 11.5281 27.0546 10.9623 26.4888 10.6087L20.7601 7.28463Z"
            fill="white"
          />
        </svg>
      </li>
    </ul>
  </>
);

export default BottomList;
